import { render, staticRenderFns } from "./tab-body.vue?vue&type=template&id=ccc40376&scoped=true&"
import script from "./tab-body.vue?vue&type=script&lang=js&"
export * from "./tab-body.vue?vue&type=script&lang=js&"
import style0 from "./tab-body.vue?vue&type=style&index=0&id=ccc40376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc40376",
  null
  
)

export default component.exports